<template>
  <div id="lineBusiness" class="col-12 p-0">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-create-lb" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              agregar línea de negocio
            </h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre de la línea de negocio"
            />
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿Cuantos puntos de venta va tener la línea de negocio?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="selected"
              :options="options"
            ></b-form-select>
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿Qué sistema de distribución de propinas por empleados se
                aplicara?</span
              >
            </p>
            <b-form-select
              class="mt-3 mb-3"
              v-model="selectedPoints"
              :options="optionsPoints"
            ></b-form-select>
            <div style="display: flex;" class="pt-2 mt-4">
              <button
                @click="nextStep1LN('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4"
                style="border: none"
                :disabled="nameLN === ''"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>

              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="$bvModal.hide('modal-create-lb')"
              >
                <span class="cta" style="width: 100%">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-create2" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de guardar está línea de negocio?
            </h3>
            <p class="pt-5">
              <span class="font-weight-bold">Nombre: </span>
              <span>{{ nameLN }}</span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Puntos de Venta: </span>
              <span v-if="selected == true">Uno solo</span>
              <span v-if="selected == false">Varios</span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Sistema de distribución: </span>
              <span v-if="selectedPoints == true">Puntajes</span>
              <span v-if="selectedPoints == false">Porcentajes</span>
            </p>
            <div style="display: flex;" class="mt-4">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep1LN('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>

              <button
                @click="nextStep1LN('save')"
                type="button"
                class="button-primary enviar-mensaje ml-4"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL PROCESO EXITOSO -->

        <b-modal id="modal-success" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-success')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL PROCESO FALLIDO -->

        <b-modal v-if="error.message" id="modal-fail" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/close.svg"
              width="20%"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.message }}</p>
            <button
              class="mt-2 mb-5 col-6 btn btn-danger"
              @click="$bvModal.hide('modal-fail')"
            >
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              Editar LÍNEA DE NEGOCIO
            </h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre de la línea de negocio"
            />
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿Cuantos puntos de venta va tener la línea de negocio?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="selected"
              :options="options"
            ></b-form-select>
            <p class="mt-5 mb-0 fs-6 col-12 p-0" style="font-size: 14px">
              <span style="text-align: left"
                >¿Qué sistema de distribución de propinas por empleados se
                aplicara?</span
              >
            </p>
            <b-form-select
              class="mt-3"
              v-model="selectedPoints"
              :options="optionsPoints"
            ></b-form-select>

            <div style="width: 100%; display: flex; margin-top: 32px">
              <button
                :disabled="checkEdit"
                @click="nextStep2LN('next')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar Cambios</span>
              </button>
              <button
                class="delete"
                style="margin-right: auto"
                @click="nextStep2LN('nextD')"
              >
                <img src="@/assets/images/icons/delete_trash_white.svg" alt="" class="ml-2 mb-2"/>
                <span class="cta ml-2"> Borrar Línea de Negocio</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit2" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de modificar la línea de negocio?
            </h3>
            <p class="pt-5">
              <span class="font-weight-bold">Nombre: </span>
              <span>{{ nameLN }}</span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Puntos de Venta: </span>
              <span v-if="selected == true">Uno solo</span>
              <span v-if="selected == false">Varios</span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Sistema de distribución: </span>
              <span v-if="selectedPoints == true">Puntajes</span>
              <span v-if="selectedPoints == false">Porcentajes</span>
            </p>
            <div style="width: 100%; display: flex; margin-top: 32px">
              <button
                type="button"
                class="button-secundary"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>

              <button
                @click="nextStep2LN('edit')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR LINEA DE NEGOCIO -->

        <b-modal id="modal-delete" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de eliminar la Línea de Negocio?
            </h3>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <span class="font-weight-bold">Nombre: </span>
              <span>{{ nameLN }}</span>
            </p>

            <div style="display: flex;" class="mt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta" >No borrar</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2LN('delete')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                  alt=""
                />
                <span class="cta ml-2"> Borrar línea de negocio</span>                
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Linea de Negocio -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Línea de Negocio +" @nuevo="create"></AddCategory>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="card mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Líneas de Negocio</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input
                type="search"
                placeholder="Buscar línea de negocio"
                aria-label="Buscar línea de negocio"
                autocomplete="off"
                class="form-control body_regular"
                v-model="datatable.filter"
                style="border: 0px"
                @keydown="startTipyng()"
                @keyup="finishTipyng()"
              />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="editLineOfBussiness(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="lineDeals.data"
                :limit="10"
                @pagination-change-page="getFilterDp"
              >
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import AddCategory from "@/components/core/button/add-category.vue";
export default {
  name: "LineBusiness",
  components: {
    SelectSettings,
    Pagination,
    AddCategory
  },
  data() {
    return {
      selected: null,
      options: [
        {
          value: null,
          text: "Selecciona una opción",
        },
        {
          value: true,
          text: "Un solo punto de venta",
        },
        {
          value: false,
          text: "Varios puntos de venta",
        },
      ],
      selectedPoints: null,
      optionsPoints: [
        {
          value: null,
          text: "Selecciona una opción",
        },
        {
          value: true,
          text: "Puntajes",
        },
        {
          value: false,
          text: "Porcentajes",
        },
      ],
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      datatable: {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.loadRows();
    this.callData();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "lineDeals",
      "lineDeal",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actLineDeals",
      "actLineDeal",
      "actSaveLineDeal",
      "actUpdateLineDeal",
      "actDeleteLineDeal",
      "actSetMessage",
      "actSetError",
    ]),

    callData(data) {
      if (data == undefined) {
        data = {
          page: this.datatable.page,
        };
      }
      this.actLineDeals(data).then(() => {
        this.lineDeals.data.data.forEach((x) => {
          this.datatable.rows.push({
            id: x.id,
            name: x.name,
          });
        });
      });
    },

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getFilterDp();
      }, 500);
    },

    create() {
      this.nameLN = "";
      this.selectedPoints = null;
      this.selected = null;
      this.$root.$emit("bv::show::modal", "modal-create-lb");
    },

    nextStep1LN(x) {
      let data = {
        name: this.nameLN,
        only_point_sale: this.selected,
        by_score: this.selectedPoints,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-create-lb");
          this.$root.$emit("bv::show::modal", "modal-create2");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2");
          this.$root.$emit("bv::show::modal", "modal-create-lb");
          break;
        case "save":
          this.actSaveLineDeal(data).then(() => {
            if (this.error.message) {
              this.$root.$emit("bv::hide::modal", "modal-delete");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.loadRows();
              this.callData();
            } else {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-create2");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.loadRows();
              this.callData();
            }
          });
          break;
        default:
      }
    },
    loadRows() {
      this.datatable = {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Líneas de Negocio",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
      ];
    },

    newLineDeal() {
      this.nameLN = "";
      this.selectedPoints = null;
      this.selected = null;
      this.$root.$emit("bv::show::modal", "modal-create-lb");
    },

    editLineOfBussiness(row) {
      this.nameLN = "";
      this.selectedPoints = null;
      this.selected = null;
      this.actLineDeal(row.id).then(() => {
        this.nameLN = this.lineDeal.name;
        switch (this.lineDeal.only_point_sale) {
          case null:
            this.selected = null;
            break;
          case 0:
            this.selected = false;
            break;
          case 1:
            this.selected = true;
            break;
        }
        switch (this.lineDeal.by_score) {
          case null:
            this.selectedPoints = null;
            break;
          case 0:
            this.selectedPoints = false;
            break;
          case 1:
            this.selectedPoints = true;
            break;
        }
      });
      this.$root.$emit("bv::show::modal", "modal-edit");
    },
    nextStep2LN(x) {
      let data = {
        id: this.lineDeal.id,
        name: this.nameLN,
        only_point_sale: this.selected,
        by_score: this.selectedPoints,
      };

      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit");
          this.$root.$emit("bv::show::modal", "modal-edit2");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2");
          this.$root.$emit("bv::hide::modal", "modal-delete");
          this.$root.$emit("bv::show::modal", "modal-edit");
          break;
        case "edit":
          this.actUpdateLineDeal(data)
            .then(() => {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-edit2");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.loadRows();
              this.callData();
            })
            .catch((response) => {
              this.nameLN = "";
              this.actSetMessage(response).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-edit2");
                this.$root.$emit("bv::show::modal", "modal-fail");
                this.loadRows();
                this.callData();
              });
            });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit");
          this.$root.$emit("bv::show::modal", "modal-delete");
          break;
        case "delete":
          this.actDeleteLineDeal(data.id).then(() => {
            if (this.error.message) {
              this.$root.$emit("bv::hide::modal", "modal-delete");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.loadRows();
              this.callData();
            } else {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-delete");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.loadRows();
              this.callData();
            }
          });
          break;
        default:
      }
    },
    getFilterDp(page = 1) {
      let data = {
        page: page,
      };
      this.loadRows();
      this.callData(data);
    },
  },
};
</script>

<style lang="scss">
#lineBusiness {
  .custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .btn-create {
    padding: 12px;
    border-radius: 20px;
    background-color: #269887;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;

    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .btn-create:hover {
    background-color: #27a391;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  }
  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    .theading {
      padding: 15px 15px;
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    tbody tr td {
      padding: 15px 15px;
      border-radius: 10px;
      cursor: pointer;
    }
    tbody tr td:hover {
      background-color: #f5f5f5;
    }
  }

  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }
}
.modal-content {
  .modal-header {
    border: none;
  }
  .input-vp2,
  /*button {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }*/
  .btn-outline-success {
    border-radius: 20px;
    color: #269887;
    border-color: #269887;
  }
  .btn-outline-success:hover,
  .btn-success {
    color: white;
    background-color: #269887;
    border-color: #269887;
  }
  .btn-success:hover {
    background-color: #27a391;
  }
  .regular {
    background-color: white;
    border: none;
    color: #269887;
  }
  .delete {
    background-color: #DA1414 !important;
    border: none;
    color: white !important;
  }
  h3 {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
  }

  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
}
</style>